/**
 * Generates a random floating-point number in the range [from, to).
 *
 * @param {number} from - The lower bound (inclusive).
 * @param {number} to - The upper bound (exclusive).
 * @returns {number} A pseudo-random float between `from` (inclusive) and `to` (exclusive).
 *
 * @example
 * randomFloat(1.5, 5.5); // Might return 3.782
 */
export function randomFloat(from, to) {
  return Math.random() * (to - from) + from;
}
